import { Channel } from '@at/sauron-platform-core'
import { FilterQueryParam } from '../search/filter-query-param-util/query-params'
import { saveToLocalStorage } from '@at/connected-search-form-builder'
import { newKeysMap, newKeysMapType } from './new-keys-map-type'
import { groupParamsByKey } from './group-params-by-key'
import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { postcodeIsValid } from '@at/formatter-utils/lib/postcode-utils/postcode-validity.util'
import { parse } from 'query-string'
import { useChannel } from '../../hooks/use-abtest.hook'

type LocalStorageFilteredValues = {
    [key: string]: string | string[] | null | number
}

export const storeSelectedSearchFilters = (channel: Channel, params: string) => {
    const updatedLocalStorageValues: LocalStorageFilteredValues = {}
    const currentParams = groupParamsByKey(new URLSearchParams(params))

    for (const [key, value] of Object.entries(currentParams)) {
        if (newKeysMap[key]) {
            updatedLocalStorageValues[newKeysMap[key].newName] = newKeysMapType(newKeysMap[key].type, value as string)

            if (newKeysMap[key].dependency?.length) {
                newKeysMap[key].dependency?.forEach((key) => {
                    updatedLocalStorageValues[newKeysMap[key].newName] = null
                })
            }
        }
    }

    //Additional parameter for finance option
    if (
        currentParams[FilterQueryParam.deposit] ||
        currentParams[FilterQueryParam.term] ||
        currentParams[FilterQueryParam.yearly_mileage]
    ) {
        updatedLocalStorageValues['financeOption'] = `${currentParams[FilterQueryParam.yearly_mileage] || '0'}_${
            currentParams[FilterQueryParam.deposit] || '0'
        }_${currentParams[FilterQueryParam.term] || '0'}`
    }
    saveToLocalStorage(channel, updatedLocalStorageValues)
}

const shouldStoreSelectedSearchFilters = (search: string) => {
    const queryParams = parse(search)
    const queryParamPostcode = queryParams[FilterQueryParam.postcode]
    if (queryParamPostcode !== undefined && typeof queryParamPostcode === 'string') {
        return postcodeIsValid(queryParamPostcode)
    }
    return !!queryParams[FilterQueryParam.lat_long] || !!queryParams[FilterQueryParam.location]
}

const useStoreSelectedSearchFilters = () => {
    const { search } = useLocation()
    const channel = useChannel()

    useEffect(() => {
        if (shouldStoreSelectedSearchFilters(search)) {
            storeSelectedSearchFilters(channel, search)
        }
    }, [search, channel])
}

export default useStoreSelectedSearchFilters
